import { choppinessIndexSeries, numericExtent } from "../utils";
const CI = {
    name: "CI",
    compute: (bars, period = 14) => choppinessIndexSeries(bars, period),
    computeExtents: (values) => numericExtent(values),
    render: () => undefined,
};
export default CI;
